/**
 * Строит DOM-дерево, подсвечивая токены запроса внутри `text`.
 *
 * Токенизатор: запрос разбивается по `\s+`, сравнение токенов без учёта регистра.
 * Стратегия совпадения: сканируем text посимвольно, на каждой позиции пробуем
 * совпасть с любым токеном (сначала самый длинный, чтобы префиксы не «съедали»).
 * Совпавший участок оборачивается в <mark>, несовпавший накапливается как текстовый узел.
 *
 * БЕЗОПАСНОСТЬ: input никогда не попадает в DOM как innerHTML. Текстовые сегменты
 * используют document.createTextNode; <mark> оборачивает совпавший участок через
 * document.createElement + присваивание textContent.
 *
 * @param {Element} container — принимает результирующее DOM-дерево
 * @param {string} text — контент для рендера
 * @param {string} query — токены через пробел для подсветки
 */
export function highlightInto(container, text, query) {
    if (!text) return;
    const tokens = (query || '')
        .split(/\s+/)
        .filter(t => t.length > 0)
        .sort((a, b) => b.length - a.length); // сначала самый длинный

    if (tokens.length === 0) {
        container.appendChild(document.createTextNode(text));
        return;
    }

    const lowerText = text.toLowerCase();
    const lowerTokens = tokens.map(t => t.toLowerCase());

    let cursor = 0;
    let plain = '';

    const flushPlain = () => {
        if (plain.length > 0) {
            container.appendChild(document.createTextNode(plain));
            plain = '';
        }
    };

    while (cursor < text.length) {
        let matched = null;
        for (const tok of lowerTokens) {
            if (lowerText.startsWith(tok, cursor)) {
                matched = tok.length;
                break;
            }
        }
        if (matched !== null) {
            flushPlain();
            const mark = document.createElement('mark');
            mark.textContent = text.slice(cursor, cursor + matched);
            container.appendChild(mark);
            cursor += matched;
        } else {
            plain += text[cursor];
            cursor++;
        }
    }
    flushPlain();
}
